import { CFormLabel } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarLabel = (props) => {
  const { children } = props
  return <CFormLabel {...props}>{children}</CFormLabel>
}

export { ConfiaCarLabel }
